export function initialize() {
    $('.resource').on('click', '.toggle-next', function() {
        var $toggle = $(this);
        var $content;
        if ($toggle.next('.next-togglable').length) {
            $content = $toggle.next('.next-togglable');
        } else {
            $content = $toggle.parent().next('.next-togglable');
        }
        $content.toggle();
    });
}

window.standards = {initialize};
